module.exports = __webpack_public_path__ + "media/images/athletes/2131-017ee563baea07e04dda667266a5a149.png";